<button
    #trigger="cdkOverlayOrigin"
    (click)="triggerNotificationOverlay()"
    cdkOverlayOrigin
    mat-icon-button
    [attr.data-cy]="'bbbbb_button_1_0_'"
>
    <mat-icon
        [matBadgeHidden]="ungelesen <= 0"
        [matBadge]="ungelesen"
        matBadgeColor="warn"
        [attr.data-cy]="'bbbbb_mat-icon_1_2_'"
        >notifications</mat-icon
    >
</button>

<ng-template
    [cdkConnectedOverlayOpen]="opened"
    [cdkConnectedOverlayOrigin]="trigger"
    cdkConnectedOverlay
    cdkConnectedOverlayHasBackdrop="true"
    (backdropClick)="opened = false"
>
    <div class="container-overlay">
        <h1 class="headline" [attr.data-cy]="'bbbbb_h1_1_4_'">Benachrichtigungen</h1>
        <kiene-benachrichtigung-uebersicht [showSupportButton]="true"></kiene-benachrichtigung-uebersicht>
    </div>
</ng-template>
